import { default as reducer } from "./reducer";
export { default as types } from "./types";
export { default as actions } from "./actions";

export default reducer;
